// extracted by mini-css-extract-plugin
module.exports = {"insight":"PageUICommunityInsight_insight__P5tOI"};